import styled from "styled-components";

const CauseListWrap = styled.div`
  padding: 12px 0;
`

export default CauseListWrap